module.exports = __webpack_public_path__ + "static/griffon-60ca378db69f94526a30f34327e9aba8.jpg";